import React from 'react'
import ReactEcharts from 'echarts-for-react'
import { OverlayTrigger, Tooltip, Container, Row } from 'react-bootstrap'

const Radar = ({ title, data }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="text-start" {...props}>
      分析您的各項指標與其他人的排名，以PR值(Percentile
      Rank)呈現。PR值95，表示您在該項得分換算排名後，高過95%的使用者。
    </Tooltip>
  )
  // const radarData =

  const radarOption = {
    color: '#DF0080',
    legend: {
      // data: ['Allocated Budget', 'Actual Spending'],
    },
    radar: {
      // shape: 'circle',
      axisName: {
        color: '#666',
        fontSize: 16,
      },
      indicator: [
        { name: '影響擴散力', max: 100 },
        { name: '話題創造力', max: 100 },
        { name: '新粉吸引力', max: 100 },
        { name: '社群觸及力', max: 100 },
        { name: '好感渲染力', max: 100 },
      ],
    },
    tooltip: {
      trigger: 'item',
    },
    series: [
      {
        type: 'radar',
        name: '優勢雷達圖',
        data: [
          {
            value: [
              data.radar_sumfoc_val,
              data.radar_avefoc_val,
              data.radar_newatt_val,
              data.radar_fanres_val,
              data.radar_emofoc_val,
            ],
            label: {
              show: true,
            },
          },
        ],
      },
    ],
  }
  return (
    <>
      <h4 className="fw-bolder p-3">
        {title}
        <OverlayTrigger
          placement="right"
          delay={{ show: 50, hide: 400 }}
          overlay={renderTooltip}
        >
          <div className="fas fa-question-circle p-1 text-decoration-none"></div>
        </OverlayTrigger>
      </h4>
      <Container>
        <Row>
          <ReactEcharts
            style={{ width: '100%', height: '500px' }}
            className="w-100"
            option={radarOption}
          />
        </Row>
      </Container>
    </>
  )
}

export default Radar
